import React from "react"
import Popover from "./Popover"

import "./MugshotCollection.css"

interface MugshotCollectionProps {
  mugshots: {
    number: number
    popover?: {
      content: string
      textColor?: string
    }
    color: string
  }[]
}

const MugshotCollection: React.FunctionComponent<MugshotCollectionProps> = ({
  mugshots,
}) => {
  return (
    <div
      className="hero-rounded-mugshotList"
      style={{ width: `${mugshots.length * 35}px` }}
    >
      {mugshots.map((val, index) => (
        <div
          key={val.number + index}
          className={"hero-rounded-mugshot " + val.color}
          style={{
            left: `calc(var(--mugshot-left) * ${index})`,
            color: val.popover.textColor || "black",
          }}
        >
          {val.popover && (
            <Popover content={val.popover.content} styleClass={val.color} />
          )}
          <img
            src={`${process.env.ASSETS_URL}headshot${val.number}.png`}
            alt={`Mugshot with ${val.number}'s image`}
          />
        </div>
      ))}
    </div>
  )
}

export default MugshotCollection
